export const airdrop_contract_address = '0xf3B941Cc71a0787418F76baebfce6eA9e46cB246'
export const zeroAddress = '0x0000000000000000000000000000000000000000'
export const airdrop_contract_address_config: any = {
  ethereum: '0x43bF78a82Bbc334b42dC2f9708D667d6aDE79eC6',
  bsc: '0x43bF78a82Bbc334b42dC2f9708D667d6aDE79eC6',
  avalanche: '0x43bF78a82Bbc334b42dC2f9708D667d6aDE79eC6',
  kcc: '0x43bF78a82Bbc334b42dC2f9708D667d6aDE79eC6',
  polygon: '0x43bF78a82Bbc334b42dC2f9708D667d6aDE79eC6',
}
